import { makeAutoObservable } from 'mobx';

class NotificationStore {
	notifications = new Map();

	constructor() {
		makeAutoObservable(this);
	}

	setNotification(incomingNotification) {
		const key = new Date().toISOString();
		this.notifications.set(key, { ...incomingNotification });
	}

	removeNotification(notificationKey) {
		this.notifications.delete(notificationKey);
	}
}

export const notificationStore = new NotificationStore();
